import type { AuthUser } from '@hemmafixa/shared';
import { createContext, useContext } from 'react';

/**
 * The user RequireArea let in. Read through context rather than the session query, so that while the session
 * ends (log out, a 401 from a background request) the pages still have the user until RequireArea has
 * redirected, instead of rendering once with no user.
 */
export const CurrentUserContext = createContext<AuthUser | null>(null);

/** The signed-in user inside an area; outside an area use `useSession()`. */
export function useCurrentUser(): AuthUser {
  const user = useContext(CurrentUserContext);
  if (!user) throw new Error('useCurrentUser must be used inside RequireArea');
  return user;
}
